import { render, staticRenderFns } from "./PTU.vue?vue&type=template&id=6e26edf0&scoped=true"
import script from "./PTU.vue?vue&type=script&lang=js"
export * from "./PTU.vue?vue&type=script&lang=js"
import style0 from "./PTU.vue?vue&type=style&index=0&id=6e26edf0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e26edf0",
  null
  
)

export default component.exports